import { render, staticRenderFns } from "./CustomerEnquiryNew.vue?vue&type=template&id=1ac19750&"
import script from "./CustomerEnquiryNew.vue?vue&type=script&lang=js&"
export * from "./CustomerEnquiryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCardSection,QForm,QInput,QField,QCheckbox,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCardSection,QForm,QInput,QField,QCheckbox,QSeparator,QCardActions,QBtn})
